/**
 * The memorial (M6 spec §5, §8; plan P32): a quiet page of the captains who died in the player's service, newest
 * first: name, ship, place, day and cause. Read-only; the focused entry carries `data-focused` (the model's focus).
 */
import type { ReactNode } from 'react'
import type { MemorialRow } from './models/memorial'
import { Portrait } from './Portrait'

export interface MemorialProps {
  rows: readonly MemorialRow[]
  /** The focused entry's index, or −1. */
  focused: number
  empty: string
}

export function Memorial(p: MemorialProps): ReactNode {
  if (p.rows.length === 0) {
    return (
      <p className="cp-memorial__empty" data-testid="memorial-empty">
        {p.empty}
      </p>
    )
  }
  return (
    <ol className="cp-memorial" data-testid="memorial" aria-label="Memorial">
      {p.rows.map((r, i) => (
        <li key={r.key} className="cp-memorial__entry" data-testid="memorial-entry" {...(i === p.focused ? { 'data-focused': '' } : {})}>
          <Portrait recipe={r.portrait} size={44} className="cp-portrait--memorial" />
          <div className="cp-memorial__text">
            <div className="cp-memorial__name">{r.name}</div>
            <div className="cp-memorial__line">
              {r.ship} · {r.place} · {r.day}
            </div>
            <div className="cp-memorial__cause">{r.cause}</div>
            <div className="cp-memorial__service">{r.service}</div>
          </div>
        </li>
      ))}
    </ol>
  )
}
